import {Theme} from '@material-ui/core/styles/createMuiTheme';
import createStyles from '@material-ui/core/styles/createStyles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export const styles = (theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      alignItems: 'center',
      wordBreak: 'break-word',
    },
    indicator: {
      marginTop: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
  });

export type Styles = Partial<WithStyles<typeof styles>>;
